import Vue from 'vue'

export default {
  getApiVersion ({ state }, instanceId) {
    const instance = state.instances.find((i) => i.id === instanceId)
    if (instanceId === true || (instance && instance.engine === '4')) {
      console.log('getApiVersion', 'engine v4')
      Vue.apiv4.defaults.headers.common.Authorization = Vue.api.defaults.headers.common.Authorization
      Vue.apiv4.defaults.headers.common['x-runstack-role'] = Vue.api.defaults.headers.common['x-runstack-role']
      return Vue.apiv4
    }
    console.log('getApiVersion', 'legacy')
    return Vue.api
  },
  getApplications ({ commit }) {
    return Vue.api.get('engine/applications')
      .then((res) => commit('init', { applications: res.data }))
  },
  getApplicationLinks ({ commit }, data) {
    return Vue.api.get('engine/applications/' + data.id + '/links')
      .then((res) => res.data)
  },
  getApplicationRepositories ({ commit }, data) {
    return Vue.api.get('engine/applications/' + data.id + '/repositories')
      .then((res) => res.data)
  },
  deployApplication ({ commit, state, dispatch }, data) {
    return dispatch('getApiVersion', data.instanceId).then((api) => api.post('engine/applications', data))
      .then((res) => commit('application', res.data))
  },
  configApplication ({ commit, state, dispatch }, data) {
    return dispatch('getApiVersion', data.instanceId).then((api) => api.put('engine/applications/' + data.id + '/config', data))
      .then((res) => commit('application', res.data))
  },
  devopsApplication ({ commit, state, dispatch }, data) {
    return dispatch('getApiVersion', data.instanceId).then((api) => api.put('engine/applications/' + data.id + '/devops', data))
      .then((res) => commit('application', res.data))
  },
  updateApplication ({ commit, state, dispatch }, data) {
    return dispatch('getApiVersion', data.instanceId).then((api) => api.put('engine/applications/' + data.id, data))
      .then((res) => commit('application', res.data))
  },
  purgeApplication ({ commit, state, dispatch }, data) {
    return dispatch('getApiVersion', data.instanceId).then((api) => api.put('engine/applications/' + data.id + '/purge', data))
  },
  cloneApplication ({ commit, state, dispatch }, data) {
    return dispatch('getApiVersion', data.instanceId).then((api) => api.post('engine/applications/' + data.id + '/clone', data))
      .then((res) => res.data)
  },
  restartApplication ({ commit, state, dispatch }, data) {
    return dispatch('getApiVersion', data.instanceId).then((api) => api.put('engine/applications/' + data.id + '/restart'))
      .then((res) => commit('application', res.data))
  },
  backupApplication ({ commit, state, dispatch }, data) {
    return dispatch('getApiVersion', data.instanceId).then((api) => api.post('engine/applications/' + data.id + '/backup'))
      .then((res) => commit('task', res.data))
  },
  restoreApplication ({ commit, state, dispatch }, data) {
    return dispatch('getApiVersion', data.instanceId).then((api) => api.post('engine/applications/' + data.id + '/restore', data))
      .then((res) => commit('application', res.data))
  },
  generateApplicationKey ({ commit }, id) {
    return Vue.api.post('engine/applications/' + id + '/generate-key')
      .then((res) => res.data)
  },
  revokeApplicationKey ({ commit }, id) {
    return Vue.api.post('engine/applications/' + id + '/revoke-key')
  },
  dedicatedIpApplication ({ commit, dispatch }, data) {
    return dispatch('getApiVersion', data.instanceId).then((api) => api.post('engine/applications/' + data.id + '/dedicated-ip'))
      .then((res) => commit('application', res.data))
  },
  shutdownApplication ({ commit, state, dispatch }, data) {
    return dispatch('getApiVersion', data.instanceId).then((api) => api.put('engine/applications/' + data.id + '/shutdown'))
      .then((res) => commit('application', res.data))
  },
  destroyApplication ({ commit, state, dispatch }, data) {
    return dispatch('getApiVersion', data.instanceId).then((api) => api.delete('engine/applications/' + data.id))
      .then((res) => commit('application', res.data))
  },
  getApplicationBackups (context, data) {
    return Vue.api.get('engine/applications/' + data.id + '/backups')
  },
  getApplicationConsole (context, data) {
    return Vue.api.post('engine/applications/' + data.id + '/console', data)
  }
}
